import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DataService, HTTPService, HelperService } from 'app/services';
import { config } from 'app/constants';
@Component({
  selector: 'app-decline-appointment-request',
  templateUrl: 'decline-appointment-request.component.html',
  styleUrls: ['decline-appointment-request.component.scss'],
})
export class DeclineAppointmentRequestComponent implements OnInit {
  constructor(public ref: DynamicDialogRef, private httpService: HTTPService, private helperService: HelperService, public dConfig: DynamicDialogConfig, private dataService: DataService) { }
  appointment = {
    title: null,
    color: config.defaultColor,
  };
  company: any = {};
  appointmentColors: any[] = [];
  qboTaxExemptReasons: any[] = [];
  appointmentTab: boolean = true;
  blockTab: boolean = false;
  declineRequestObj = {
    template: ``,
    isSendMsg: false,
    declineReason: '',
    isSms: false,
    isEmail: false,
    isDeclined: true,
  };
  errors: any = {};
  request: any;
  isProcessing = false;
  template: any = {};
  companyLocalization: boolean = false;
  currentLang: string = 'en';

  ngOnInit() {
    this.request = this.dConfig.data && JSON.stringify(this.dConfig.data.data);
    this.isProcessing = false;
    const localizationSubscription = this.dataService.getCompanyLocalization().subscribe((value) => {
      if (value) {
        this.companyLocalization = value
        this.currentLang = JSON.parse(this.request).language || 'en';
      } else {
        this.currentLang = 'en';
      }
    })
    localizationSubscription.unsubscribe();
    this.getTemplatesByType();
  }

  async getTemplatesByType() {
    const response = await this.httpService.getTemplatesByTypeLang('APPT_REQ_DECLINED', this.currentLang.toUpperCase());
    this.template = response;
    this.declineRequestObj.template = response.contents;
    if (response.cancellationText) {
      this.declineRequestObj.template = response.cancellationText;
    }
  }

  handleRadioChange(type, value) {
    this.declineRequestObj[type] = value;
    this.errors[type] = '';
  }

  onColorChange(color: any) {
    this.appointment.color = color;
  }

  close() {
    this.ref.close({
      data: true,
    });
  }

  changeTemplate(e) {
    this.declineRequestObj.template = e.target.value;
  }

  declineRequest() {
    let payLoad: any = Object.assign({}, JSON.parse(this.request));
    payLoad.startDateTime = payLoad.start;
    payLoad.status = 'declined';
    this.isProcessing = true;
    payLoad.declineReason = this.declineRequestObj.declineReason;
    payLoad.type = 'customer';
    payLoad.cancellationText = this.declineRequestObj.template;
    let decline = {
      isEmail: this.declineRequestObj.isEmail,
      isSms: this.declineRequestObj.isSms,
      isDeclined: this.declineRequestObj.isDeclined,
      isSendMsg: this.declineRequestObj.isSendMsg,
    };

    delete payLoad.start;
    delete payLoad.end;

    if (this.template._id) {
      // this.httpService
      //   .updateTemplate({
      //     type: this.template.type,
      //     name: this.template.name,
      //     subject: this.template.subject,
      //     contents: this.declineRequestObj.template,
      //     footer: this.template.footer,
      //     htmlContents: 'htmlContents',
      //     smsFooter: this.template.smsFooter,
      //     _id: this.template._id,
      //   })
      //   .then((response) => {
      this.updateAppointmentRequest(payLoad, decline);
      // })
      // .catch((x) => (this.isProcessing = false));
    } else {
      this.httpService
        .createTemplate({
          type: this.template.type,
          name: this.template.name,
          subject: this.template.subject,
          contents: this.declineRequestObj.template,
          footer: this.template.footer,
          htmlContents: 'htmlContents',
          smsFooter: this.template.smsFooter,
        })
        .then((response) => {
          this.updateAppointmentRequest(payLoad, decline);
        })
        .catch((x) => (this.isProcessing = false));
    }
  }

  async updateAppointmentRequest(payload: any, decline: any) {
    try {
      await this.httpService.updateAppointmentRequest(payload, decline);
      this.helperService.showToaster('success', 'Request declined');
      this.dataService.sendData(this.dataService.typePassData('appt-decline-request', { data: payload }));
      this.dataService.sendData(this.dataService.typePassData('update-appt-column', { data: payload }));
      this.ref.close();
      this.isProcessing = false;
    } catch (err) {
      this.helperService.showToaster('error', err);
    } finally {
      this.isProcessing = false;
    }
  }
}
